import { render, staticRenderFns } from "./Setbank.vue?vue&type=template&id=4f083464&scoped=true"
import script from "./Setbank.vue?vue&type=script&lang=js"
export * from "./Setbank.vue?vue&type=script&lang=js"
import style0 from "./Setbank.vue?vue&type=style&index=0&id=4f083464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f083464",
  null
  
)

export default component.exports